import { render } from "./ICalDownloader.vue?vue&type=template&id=85047a56&scoped=true"
import script from "./ICalDownloader.vue?vue&type=script&lang=js"
export * from "./ICalDownloader.vue?vue&type=script&lang=js"

import "./ICalDownloader.vue?vue&type=style&index=0&id=85047a56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85047a56"]])

export default __exports__